import request from '@apps-common/js-client/api/request';
import {DATA_API_BASE_URL} from '@account/config';
import {useQuery} from '@tanstack/react-query';

const getItemTypes = () =>
  request
    .get(`${DATA_API_BASE_URL}/item-types`)
    .then(res => res.data.item_types);

export const useGetItemTypes = () =>
  useQuery({
    queryKey: ['itemTypes'],
    queryFn: () => getItemTypes(),
    // The item-type catalog is static and only enriches labels — it must never
    // hold up the views that use it. Cache it and fail fast so a Data API
    // hiccup degrades to plain labels instead of a long retry storm.
    staleTime: 60 * 60 * 1000,
    retry: 1,
  });
